import { object, array, number, string, boolean } from '@gogame/schemas';

import {
  DESIGNER,
  CREATIVE_TYPE,
  COLOR,
  ENHANCERS,
  NETWORKS,
  TAGS,
  CHANNELS,
  POSTFIX,
  OS,
  LANGUAGE,
  DESCRIPTION,
  APPLICATION,
  AI_GENERATED,
} from 'scenes/Gallery/GalleryPage/Creatives/constants';

export const creativeValidationSchema = object({
  [CREATIVE_TYPE]: number().required('Creative type is required'),
  [COLOR]: number(),
  [ENHANCERS]: array(number()),
  [NETWORKS]: array(number()).required('Networks is required'),
  [TAGS]: array(number()),
  [CHANNELS]: array(number()),
  [DESIGNER]: number(),
  [OS]: number(),
  [LANGUAGE]: number().required('Language is required'),
  [POSTFIX]: string(),
  [DESCRIPTION]: string(),
  [APPLICATION]: number(),
  [AI_GENERATED]: boolean(),
});
